import * as Types from '../../../graphql.generated';

export type UpdateUserConsentsMutationVariables = Types.Exact<{
    input: Types.UpdateUserConsentsInput;
}>;

export type UpdateUserConsentsMutation = { __typename?: 'Mutation' } & Pick<
    Types.Mutation,
    'updateUserConsents'
>;

export const UpdateUserConsentsDocument = `
    mutation updateUserConsents($input: UpdateUserConsentsInput!) {
  updateUserConsents(input: $input)
}
    `;
export type Requester<C = {}, E = unknown> = <R, V>(
    doc: string,
    vars?: V,
    options?: C
) => Promise<R>;
export function getSdk<C, E>(requester: Requester<C, E>) {
    return {
        updateUserConsents(
            variables: UpdateUserConsentsMutationVariables,
            options?: C
        ): Promise<UpdateUserConsentsMutation> {
            return requester<
                UpdateUserConsentsMutation,
                UpdateUserConsentsMutationVariables
            >(UpdateUserConsentsDocument, variables, options);
        }
    };
}
export type Sdk = ReturnType<typeof getSdk>;
